import jscookie from 'js-cookie'
import moment from 'moment'
import Leaflet from 'leaflet'
import { post as esriPost } from 'esri-leaflet'
import router from '../../router'

export const AUTH_COOKIE = 'if_auth_token'
export const AUTH_API_COOKIE = "if_api_auth_token"
export const AUTH_API_PHOTO_COOKIE = "if_api_photo_auth_token"
export const NETID_COOKIE = "if_netid"
export const IGNORE_MOTD_DATE = "if_ignore_motd_date"
export const LINE_DETAIL_COOKIE = "if_line_detail"
//export const USE_BETA_GIS = "if_use_beta_gis"
//const API_IP = "128.196.84.194"
const API_IP = "10.222.42.46"
const API_PHOTO_IP = "128.196.84.194"


function setExpiration() {
  let rightNow = moment()
  let midnight = moment().add(1, 'd').startOf('day')

  return midnight.diff(rightNow, 'minutes')
}


// Meaningless test comment
const state = {
  collections : [],
  userManagedDepts: [],
  userOccupantEditorDepts: [],
  viewRestricted: false,
  isSuperUser: false,
  loginFail: false,
  userProfile: {},
  usersWithRights: [],
  roles: [],
  impersonate: null,
  userRoleDescription: null,
  numberOfloginFails: 0
}

const getters = {

  impersonateID: (state) => {
    return state.impersonate && state.impersonate.employeeID
  },

  // Test user profile for role (i.e. Manager, occupant_editor, CTS, Sign Shop)
  hasRole: (state) => (role) => {
    if (state.roles.includes(role)) { return true }
  },

  // Test for UI.  Is this a manager of (Dept)?
  isManagerOfDept : (state) => (dept) => {
    let managed = state.userManagedDepts.find((managedDepts) => managedDepts == dept.deptID )
    if (managed) {
      //console.log("IsManagerOfDept: true")
      return true
    } else { 
      //console.log("IsManagerOfDept: true") 
    }
  },

  isOccupantEditorOfDept : (state) => (dept) => {
    let editor = state.userOccupantEditorDepts.find((occupantEditorDepts) => occupantEditorDepts == dept.deptID )
    if (editor) {
      return true
    }
  },

  // True if ANY of logged in user's occupanteditor depts are assigned to this room.
  // This is untested
  isOccupantEditorOfRoom: (state) => (room) => {
    if (!room || !room.PCT) { return false }
    let roomDepts = []
    let retCode = false
    room.PCT.forEach((dept) => roomDepts.push(dept.deptID) )
    
    state.userOccupantEditorDepts.forEach((userDept) => {
      roomDepts.forEach((dept) => {
        if (userDept == dept) {
          console.log("Match", dept)
          retCode = true
        }
      })
    })
    return retCode
  },
  
  // True if ANY of logged in user's managed depts are assigned to this room.
  isManagerOfRoom: (state) => (room) => {
    if (!room || !room.PCT) { return false }

    let roomDepts = []
    let retCode = false
    room.PCT.forEach((dept) => roomDepts.push(dept.deptID) )
    
    state.userManagedDepts.forEach((userDept) => {
      roomDepts.forEach((dept) => {
        if (userDept == dept) {
          //console.log("Match", dept)
          retCode = true
        }
      })
    })
    return retCode
  },

  // Helper with showing UI components.  Is this user a manager of anything?
  allowManagerUI: (state, getters, rootState) => {
    //console.log("Checking if this is a manager: ", state.userManagedDepts)
    if (state.userManagedDepts.length > 0 ) {
      return true
    }
  },

  allowOccupantEditorUI: (state, getters, rootState) => {
    //console.log("Checking if this is a manager: ", state.userManagedDepts)
    if (state.userOccupantEditorDepts.length > 0 ) {
      return true
    }
  },

  ignoreMOTDDate: (state) => {
    return jscookie.get(IGNORE_MOTD_DATE)
  },

}

const mutations = {
  setIsSuperUser(state, payload) {
    state.isSuperUser = payload
  },

  setImpersonate(state, payload) {
    state.impersonate = payload
  },  

  setCollections(state, payload = '') {
    payload.forEach((group) => {
      group.collections.forEach((collection) => {
          collection.rooms = sortRooms(collection.rooms)
      })
   })
   state.collections = payload
   function sortRooms(items) {
      return items.sort((a, b) => (a.number < b.number) ? 1 : -1)
   }
  },

  setUserManagedDepts(state, payload) {    
    state.userManagedDepts = payload
    //console.log(state.userManagedDepts)
  },

  setUserOccupantEditorDepts(state, payload) {    
    state.userOccupantEditorDepts = payload
  },

  setUsersWithRights(state, payload) {    
    state.usersWithRights = payload
  },

  setViewRestricted(state, payload) {
    state.viewRestricted = payload
  },

  setLoginFail(state, payload) {
    state.loginFail = payload
  },

  setUserProfile(state, payload) {
    state.userProfile = payload
  },

  setUserRoles(state, payload) {
    state.roles = payload
  },

  setMapCenter(state, payload) {
    jscookie.set('mapCenter', payload)
  },

  setUserRoleDescription(state, payload){
    state.userRoleDescription = payload
  },

  incrementNumberOfLoginFails(state){
    state.numberOfloginFails++
  }

}

const actions = {

  async generateToken({state, commit, getters}, payload) {
    let tokenURL = payload.payload.tokenURL
    let password = payload.payload.password
    let netId = payload.payload.netId.split('@')[0]
    return new Promise((resolve, reject) => {
      console.log("TokenURL: ", tokenURL)
      
    esriPost('https://services.maps.arizona.edu/pdc/tokens/generateToken', {
    //esriPost(tokenURL, {
          username: netId.trim(),
          password,
          f: 'json',
          expiration: setExpiration(),
          client: 'referer',
          referer: window.location.origin
        }, (error, response) => {
          if (error) {
            console.log(error)
            state.loginFail = true
            commit('incrementNumberOfLoginFails')
            return error
          }
  
          if (!response.token) return reject(new Error('[generateToken] did not provide a valid token'))
  
          let clientResponse = response
  
          // expires at midnight
          jscookie.set(AUTH_COOKIE, clientResponse.token, { expires: moment().add(setExpiration(), 'm').toDate() })
          jscookie.set(NETID_COOKIE, netId)
  
           // Token required for photo api.  Uses IP restriction.
           esriPost('https://services.maps.arizona.edu/pdc/tokens/generateToken', {
            username: netId.trim(),
            password,
            f: 'json',
            expiration: setExpiration(),
            client: 'ip',
            ip: API_PHOTO_IP
          }, (error, response) => {
            if (error) return reject(error)
            if (!response.token) reject('[generateToken:api] did not provide a valid token')
  
            let clientPhotoResponse = response

            // expires at midnight
            jscookie.set(AUTH_API_PHOTO_COOKIE, clientPhotoResponse.token, { expires: moment().add(setExpiration(), 'm').toDate() })
  
          })

          // Second token required for api.  Uses IP restriction.
          esriPost('https://services.maps.arizona.edu/pdc/tokens/generateToken', {
            username: netId.trim(),
            password,
            f: 'json',
            expiration: setExpiration(),
            client: 'ip',
            ip: API_IP
          }, (error, response) => {
            if (error) return reject(error)
            if (!response.token) reject('[generateToken:api] did not provide a valid token')
  
            let clientResponse = response
  
            // expires at midnight
            jscookie.set(AUTH_API_COOKIE, clientResponse.token, { expires: moment().add(setExpiration(), 'm').toDate() })
  
            // Log this user
            fetch("https://api.ba.arizona.edu/if/interactivefloorplans/saveusermetric",
                          {
                              headers: {
                              'Accept': 'application/json',
                              'Content-Type': 'application/json',
                              'apiEsriToken': clientResponse.token
                              },
                              method: "POST",
                              body: JSON.stringify(null)
                      })
  
            return resolve(clientResponse)
          })
  
        })
    })
  },

  
    async login({ commit, dispatch, getters }, payload) {
        //console.log("Action: login ")
        payload.tokenURL = getters.tokenURL
        let token = await this.dispatch('generateToken', {payload})
        //console.log("Token: ", token)
        router.push({ path: '/login',  })
        return token
    },

    async logout({ commit, dispatch }, payload) {
        jscookie.remove(AUTH_COOKIE)
        jscookie.remove(AUTH_API_COOKIE)
    },

    setIgnoreMOTDDate(state, payload) {
        jscookie.set(IGNORE_MOTD_DATE, payload, { expires: 365 })
    },

    setBetaGISCookie(state, payload) {
        jscookie.set(USE_BETA_GIS, payload)
    },

  fetchUsersWithRights ({commit, getters}, payload) {
    const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      return new Promise((resolve, reject) => {
        fetch("https://api.ba.arizona.edu/if/user/roles",
        {
            headers: {
            'database' : getters.getDatabase(),  
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'apiEsriToken': apiEsriToken,
            'impersonate' : getters.impersonateID,
            },

        }).then((response) => {
            if (response.ok) { 
                return response.json() 
            } else {
                throw new Error('Something went wrong.');
            }
        }).then((data) => { 
            let key=1 // generic key
            data.forEach((user) => {
              user.key = key
              user.revoke = 'X'   // weird, but this serves as the icon/placeholder button to revoke people in datatable for dept/college space permissions
              user.remove = false
              key = key + 1
            })
            resolve(data)
            commit('setUsersWithRights', data)
        })
      })
  },  

  fetchPermissionsByNetId ({commit, getters}, payload) {
      const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      return new Promise((resolve, reject) => {
        fetch("https://api.ba.arizona.edu/if/user/permissions/roles",
        {
            headers: {
            'database' : getters.getDatabase(),  
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'apiEsriToken': apiEsriToken,
            'impersonate' : getters.impersonateID,
            },
            method: "POST",
            body: JSON.stringify(payload)

        }).then((response) => {
            if (response.ok) { 
                return response.json() 
            } else {
                throw new Error('Something went wrong.');
            }
        }).then((data) => { 
            resolve(data)
        })
      })
  },

  fetchSetPermissions ({commit, getters}, payload) {
      const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      return new Promise((resolve, reject) => {
        fetch("https://api.ba.arizona.edu/if/user/permissions/setroles ",
        {
            headers: {
            'database' : getters.getDatabase(),  
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'apiEsriToken': apiEsriToken,
            'impersonate' : getters.impersonateID,
            },
            method: "POST",
            body: JSON.stringify(payload)

        }).then((response) => {
            if (response.ok) { 
                return response.json() 
            } else {
                throw new Error('Something went wrong.');
            }
        }).then((data) => { 
            resolve(data)
        })
      })
  },

  fetchUserManagedDepts ({commit, getters}) {
      const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      //console.log("Action: UserManagedDepts ")
      fetch("https://api.ba.arizona.edu/if/user/spacemanagerofdepartments",
      {
          headers: {
          'database' : getters.getDatabase(),  
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'apiEsriToken': apiEsriToken,
          'impersonate' : getters.impersonateID,
          },


      }).then((response) => {
          if (response.ok) { 
              return response.json() 
          } else {
              throw new Error('Something went wrong.');
          }
      }).then((data) => { 
          //console.log("Setting Managed Dept Data")
          this.commit('setUserManagedDepts', data) 
      })
  },

  fetchUserPermissions ({commit, getters}) {
      const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      //console.log("Action: UserManagedDepts ")
      fetch("https://api.ba.arizona.edu/if/user/permissions",
      {
          headers: {
          'database' : getters.getDatabase(),  
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'apiEsriToken': apiEsriToken,
          'impersonate' : getters.impersonateID,
          },

      }).then((response) => {
          if (response.ok) { 
              return response.json() 
          } else {
              throw new Error('Something went wrong.');
          }
      }).then((data) => { 
          //console.log("Setting Permissions", data)
          this.commit('setUserManagedDepts', data.manager) 
          this.commit('setUserOccupantEditorDepts', data.occupant_editor)
          this.commit('setUserRoles', data.roles)
      })
  },

  fetchUsersLayerList ({commit}) {
      //console.log("Action: fetchUsersLayerList ")
      let token     = jscookie.get(AUTH_COOKIE)
      return new Promise((resolve, reject) => {
        fetch('https://services.maps.arizona.edu/pdc/rest/?f=pjson&token=' + token)
            .then(response => response.json())
            .then(data => {
              //console.log(data)
              resolve(data)
            })
            .catch(e => {
              console.log(e);
              reject()
              return 
          })
      })
    },

    interiorServiceCheck ({commit}) {
      //console.log("Action: fetchUsersLayerList ")
      let token     = jscookie.get(AUTH_COOKIE)
      return new Promise((resolve, reject) => {
        fetch('https://services.maps.arizona.edu/pdc/rest/services/Interior/MapServer/16/query?where=BldgName+%3D+%27Old+Main%27&f=pjson&token=' + token)
            .then(response => response.json())
            .then(data => {
              //console.log(data)
              resolve(data)
            })
            .catch(e => {
              console.log(e);
              reject()
              return 
          })
      })
    },


/*  fetchCollections ({commit, getters}) {
      const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      //console.log("Action: fetchCollections ")
      fetch("https://api.ba.arizona.edu/if/userRoomCollection",
      {
          headers: {
          'database' : getters.getDatabase(),
          'Content-Type': 'application/json',
          'apiEsriToken': apiEsriToken
          },

      }).then((response) => {
          if (response.ok) { 
              return response.json() 
          } else {
              throw new Error('No Collections, or error.');
          }
      }).then((data) => { 
          //console.log("Setting Collections Data", data)

          
          if (data != "No data") { 

            // Upgrade data to new format including "Groups" if needed.
            if (data[0].collection) {  // Test of old format
              //console.log("Convert collections to group format")
              data = [ { 'group': 'Default Collection Group', 'collections': data }]
            } else {
              //console.log("Already Converted", data)
            }
            //console.log(data)


            this.commit('setCollections', data) 
          }
      })
  },*/

  fetchIsSuperUser ({commit, getters}) {
    const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      //console.log("Action: fetchIsSuperUser ")
      fetch("https://api.ba.arizona.edu/if/user/isSuper",
      {
          headers: {
          'database' : getters.getDatabase(),
          'Content-Type': 'application/json',
          'apiEsriToken': apiEsriToken,
          'impersonate' : getters.impersonateID,
          },

      }).then((response) => {
          if (response.ok) { 
              return response.json() 
          } else {
              throw new Error('Something went wrong fetching isSuperUser.');
          }
      }).then((data) => { 
          let parse = JSON.parse(data)
          this.commit('setIsSuperUser', parse) 
          
          // Exceptions to enable full interface for some people.  This does not affect backend security
          if (state.userProfile.netid == 'grantmc' ||
              state.userProfile.netid == 'naveedahmed' ||
              state.userProfile.netid == 'mareemarchuleta'
            ) { this.commit('setIsSuperUser', true) }
      })
  },

  fetchUserProfile ({commit, getters}) {
    return new Promise((resolve, reject) => {
      const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      //console.log("Action: fetchUserProfile ")
      fetch("https://api.ba.arizona.edu/if/user/profile",
      {
          headers: {
          'database' : getters.getDatabase(),
          'Content-Type': 'application/json',
          'apiEsriToken': apiEsriToken,
          'impersonate' : getters.impersonateID,
          },

      }).then((response) => {
          if (response.ok) { 
              return response.json() 
          } else {
              console.log("Fetch profile failed or no Profile present")
              this.commit('setUserProfile', {})
              resolve()
          }
      }).then((data) => { 
          //data.netid="garciajs"  // can perform some impersonation with this.
          if (data) { this.commit('setUserProfile', data) }
          else { this.commit('setUserProfile', {}) }
      })
    })
  },

  copyCollection ({commit, getters}, payload) {
    const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      //console.log("Action: copyCollection ")
      return new Promise((resolve, reject) => {
        fetch("https://api.ba.arizona.edu/if/user/copyCollection",
        {
            headers: {
            'database' : getters.getDatabase(),
            'Content-Type': 'application/json',
            'apiEsriToken': apiEsriToken,
            'impersonate' : getters.impersonateID,
            },
            method: "POST",
            body: JSON.stringify(payload)

        }).then(response => resolve(response.json()))
      })
  },

  copyCollectionGroup ({commit, getters}, payload) {
    const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      //console.log("Action: copyCollection ")
      return new Promise((resolve, reject) => {
        fetch("https://api.ba.arizona.edu/if/user/copyCollectionGroup",
        {
            headers: {
            'database' : getters.getDatabase(),
            'Content-Type': 'application/json',
            'apiEsriToken': apiEsriToken,
            'impersonate' : getters.impersonateID,
            },
            method: "POST",
            body: JSON.stringify(payload)

        }).then(response => resolve(response.json()))
      })
  },

  updateUserProfile ({commit, getters}, payload) {
    const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      //console.log("Action: fetchIsSuperUser ")
      //fetch("https://api.ba.arizona.edu/if/user/profile/update",
      fetch("https://api.ba.arizona.edu/if/user/profile/update",
      {
          headers: {
          'database' : getters.getDatabase(),
          'Content-Type': 'application/json',
          'apiEsriToken': apiEsriToken,
          'impersonate' : getters.impersonateID,
          },
          method: "POST",
          body: JSON.stringify(payload)

      }).then((response) => {
          if (response.ok) { 
              return response.json() 
          } else {
              throw new Error('Something went wrong updating User Profile.');
          }
      })
  },

  updatePermissionsRoleMembers ({commit, getters}, payload) {
    const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
      console.log("Action: updatePermissionsRoleMembers ")
      fetch("https://api.ba.arizona.edu/if/user/role/updateMembers",      
      {
          headers: {
          'database' : getters.getDatabase(),
          'Content-Type': 'application/json',
          'apiEsriToken': apiEsriToken,
          'impersonate' : getters.impersonateID,
          },
          method: "POST",
          body: JSON.stringify(payload)

      }).then((response) => {
          if (response.ok) { 
              return response.json() 
          } else {
              throw new Error('Something went wrong updating User Profile.');
          }
      })
  },

  fetchUserRoleDescription ({commit, getters}) {
    const apiEsriToken          = jscookie.get(AUTH_API_COOKIE)
    //console.log("Action: UserManagedDepts ")
    fetch("https://api.ba.arizona.edu/if/user/roles/description",
    {
        headers: {
        'database' : getters.getDatabase(),  
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'apiEsriToken': apiEsriToken,
        'impersonate' : getters.impersonateID,
        },


    }).then((response) => {
        if (response.ok) { 
            return response.json() 
        } else {
            throw new Error('Something went wrong.');
        }
    }).then((data) => { 
      this.commit('setUserRoleDescription', data)
  })
},

  initializeData ({rootState, dispatch, commit}, payload) {
      //console.log("Checking for local data")
        if (rootState.space.buildings.length==0 || payload) {
          //console.log("Fetch Initial Data")
          this.dispatch('fetchUserProfile')
          this.dispatch('fetchBuildings')
          this.dispatch('refreshLists')
          this.dispatch('fetchColleges')
          this.dispatch('fetchIsSuperUser')     // Client Side Permissions  
          this.dispatch('fetchUserPermissions') // Combined permissions fetch (Manager, OccupantEditor)
          this.dispatch('fetchDeptColors')
          this.dispatch('fetchCategoryColors')
          this.dispatch('fetchUserRoleDescription')          
          //this.commit( 'setShowLineDetail', jscookie.get(LINE_DETAIL_COOKIE) == true ? true : false ) 
          this.dispatch('getLineDetailCookie')
        }
  }

}

export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js